// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  display: flex;
  overflow: auto;
  z-index: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
:host::-webkit-scrollbar {
  background: transparent;
  width: 0;
  height: 0;
}

.content {
  position: relative;
  z-index: 0;
  flex: 1;
}

.bars {
  position: sticky;
  top: 0;
  left: 0;
  min-width: 100%;
  margin-right: -100%;
  pointer-events: none;
  z-index: 1;
}

.bar {
  position: absolute;
  right: -15px;
  bottom: 0;
}
.bar_vertical {
  top: 0;
}
.bar_has-vertical {
  right: 8px;
}

.thumb {
  position: absolute;
  border-radius: 100px;
  border: 4px solid transparent;
  background-color: rgba(112, 112, 112, 0.24);
  cursor: pointer;
  pointer-events: auto;
  background-clip: content-box;
  box-sizing: border-box;
}
.thumb:hover, .thumb:active {
  background-color: rgba(112, 112, 112, 0.56);
}
.bar_vertical .thumb {
  right: 0;
  width: 12px;
  min-height: 24px;
}
.bar_vertical .thumb:hover, .bar_vertical .thumb:active {
  width: 14px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjcm9sbGJhci5zdHlsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0VBQ0Msa0JBQUE7RUFDQSxhQUFBO0VBQ0EsY0FBQTtFQUNBLFVBQUE7RUFDQSxxQkFBQTtFQUNBLHdCQUFBO0FBREQ7QUFHQztFQUNDLHVCQUFBO0VBQ0EsUUFBQTtFQUNBLFNBQUE7QUFERjs7QUFLQTtFQUNDLGtCQUFBO0VBQ0EsVUFBQTtFQUNBLE9BQUE7QUFGRDs7QUFLQTtFQUNDLGdCQUFBO0VBQ0EsTUFBQTtFQUNBLE9BQUE7RUFDQSxlQUFBO0VBQ0EsbUJBQUE7RUFDQSxvQkFBQTtFQUNBLFVBQUE7QUFGRDs7QUFLQTtFQUNDLGtCQUFBO0VBQ0EsWUFBQTtFQUNBLFNBQUE7QUFGRDtBQUlDO0VBQ0MsTUFBQTtBQUZGO0FBS0M7RUFDQyxVQUFBO0FBSEY7O0FBT0E7RUFDQyxrQkFBQTtFQUNBLG9CQUFBO0VBQ0EsNkJBQUE7RUFDQSwyQ0FBQTtFQUNBLGVBQUE7RUFDQSxvQkFBQTtFQUNBLDRCQUFBO0VBQ0Esc0JBQUE7QUFKRDtBQU1DO0VBRUMsMkNBQUE7QUFMRjtBQVFDO0VBQ0MsUUFBQTtFQUNBLFdBQUE7RUFDQSxnQkFBQTtBQU5GO0FBU0M7RUFFQyxXQUFBO0FBUkYiLCJmaWxlIjoic2Nyb2xsYmFyLnN0eWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJAaW1wb3J0ICd2YXJpYWJsZXMnO1xuXG46aG9zdCB7XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0ZGlzcGxheTogZmxleDtcblx0b3ZlcmZsb3c6IGF1dG87XG5cdHotaW5kZXg6IDA7XG5cdHNjcm9sbGJhci13aWR0aDogbm9uZTtcblx0LW1zLW92ZXJmbG93LXN0eWxlOiBub25lO1xuXG5cdCY6Oi13ZWJraXQtc2Nyb2xsYmFyIHtcblx0XHRiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcblx0XHR3aWR0aDogMDtcblx0XHRoZWlnaHQ6IDA7XG5cdH1cbn1cblxuLmNvbnRlbnQge1xuXHRwb3NpdGlvbjogcmVsYXRpdmU7XG5cdHotaW5kZXg6IDA7XG5cdGZsZXg6IDE7XG59XG5cbi5iYXJzIHtcblx0cG9zaXRpb246IHN0aWNreTtcblx0dG9wOiAwO1xuXHRsZWZ0OiAwO1xuXHRtaW4td2lkdGg6IDEwMCU7XG5cdG1hcmdpbi1yaWdodDogLTEwMCU7XG5cdHBvaW50ZXItZXZlbnRzOiBub25lO1xuXHR6LWluZGV4OiAxO1xufVxuXG4uYmFyIHtcblx0cG9zaXRpb246IGFic29sdXRlO1xuXHRyaWdodDogLTE1cHg7XG5cdGJvdHRvbTogMDtcblxuXHQmX3ZlcnRpY2FsIHtcblx0XHR0b3A6IDA7XG5cdH1cblxuXHQmX2hhcy12ZXJ0aWNhbCB7XG5cdFx0cmlnaHQ6IDhweDtcblx0fVxufVxuXG4udGh1bWIge1xuXHRwb3NpdGlvbjogYWJzb2x1dGU7XG5cdGJvcmRlci1yYWRpdXM6IDEwMHB4O1xuXHRib3JkZXI6IDRweCBzb2xpZCB0cmFuc3BhcmVudDtcblx0YmFja2dyb3VuZC1jb2xvcjogcmdiYSgkY29sb3Itc3VyZmFjZS1kYXJrLCAwLjI0KTtcblx0Y3Vyc29yOiBwb2ludGVyO1xuXHRwb2ludGVyLWV2ZW50czogYXV0bztcblx0YmFja2dyb3VuZC1jbGlwOiBjb250ZW50LWJveDtcblx0Ym94LXNpemluZzogYm9yZGVyLWJveDtcblxuXHQmOmhvdmVyLFxuXHQmOmFjdGl2ZSB7XG5cdFx0YmFja2dyb3VuZC1jb2xvcjogcmdiYSgkY29sb3Itc3VyZmFjZS1kYXJrLCAwLjU2KTtcblx0fVxuXG5cdC5iYXJfdmVydGljYWwgJiB7XG5cdFx0cmlnaHQ6IDA7XG5cdFx0d2lkdGg6IDEycHg7XG5cdFx0bWluLWhlaWdodDogMjRweDtcblx0fVxuXG5cdC5iYXJfdmVydGljYWwgJjpob3Zlcixcblx0LmJhcl92ZXJ0aWNhbCAmOmFjdGl2ZSB7XG5cdFx0d2lkdGg6IDE0cHg7XG5cdH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/core/plugins/scrollbar/scrollbar.style.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,wBAAA;AADD;AAGC;EACC,uBAAA;EACA,QAAA;EACA,SAAA;AADF;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,OAAA;AAFD;;AAKA;EACC,gBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AAFD;;AAKA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;AAFD;AAIC;EACC,MAAA;AAFF;AAKC;EACC,UAAA;AAHF;;AAOA;EACC,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,2CAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,sBAAA;AAJD;AAMC;EAEC,2CAAA;AALF;AAQC;EACC,QAAA;EACA,WAAA;EACA,gBAAA;AANF;AASC;EAEC,WAAA;AARF;AACA,o1EAAo1E","sourcesContent":["@import 'variables';\n\n:host {\n\tposition: relative;\n\tdisplay: flex;\n\toverflow: auto;\n\tz-index: 0;\n\tscrollbar-width: none;\n\t-ms-overflow-style: none;\n\n\t&::-webkit-scrollbar {\n\t\tbackground: transparent;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n}\n\n.content {\n\tposition: relative;\n\tz-index: 0;\n\tflex: 1;\n}\n\n.bars {\n\tposition: sticky;\n\ttop: 0;\n\tleft: 0;\n\tmin-width: 100%;\n\tmargin-right: -100%;\n\tpointer-events: none;\n\tz-index: 1;\n}\n\n.bar {\n\tposition: absolute;\n\tright: -15px;\n\tbottom: 0;\n\n\t&_vertical {\n\t\ttop: 0;\n\t}\n\n\t&_has-vertical {\n\t\tright: 8px;\n\t}\n}\n\n.thumb {\n\tposition: absolute;\n\tborder-radius: 100px;\n\tborder: 4px solid transparent;\n\tbackground-color: rgba($color-surface-dark, 0.24);\n\tcursor: pointer;\n\tpointer-events: auto;\n\tbackground-clip: content-box;\n\tbox-sizing: border-box;\n\n\t&:hover,\n\t&:active {\n\t\tbackground-color: rgba($color-surface-dark, 0.56);\n\t}\n\n\t.bar_vertical & {\n\t\tright: 0;\n\t\twidth: 12px;\n\t\tmin-height: 24px;\n\t}\n\n\t.bar_vertical &:hover,\n\t.bar_vertical &:active {\n\t\twidth: 14px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
